import React from 'react';
import styles from '../../styles/components/reports/QuestionReportPreview.module.css';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import { getTemplateText } from '@ax2/common/helpers/template';
import parse from 'html-react-parser';

export interface QuestionReportPreviewData {
  question: QuestionSchema;
}

export const QuestionReportPreview: React.FC<QuestionReportPreviewData> = ({
  question,
}) => {
  return (
    <div className={styles.previewContainer}>
      <span className={styles.questionTitle}>Your question</span>
      <span className={styles.questionText}>
        {'content' in question
          ? parse(getTemplateText(question.content))
          : 'Empty question content'}
      </span>
    </div>
  );
};
